import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';

import { rootSiteSelector, siteFromRootSiteSelector } from 'selectors/root-site';

export const useSiteConfigurations = () => {
  const { siteSlug } = useParams();

  const selector = useMemo(() => (siteSlug ? siteFromRootSiteSelector(siteSlug) : rootSiteSelector), [siteSlug]);

  return useSelector(selector);
};

export const useSiteStyleConfigurations = () => {
  const { fonts, imageCornerRoundness, buttonRadius } = useSiteConfigurations();

  return useMemo(
    () => ({ fonts, borderRadius: imageCornerRoundness, buttonRadius }),
    [fonts, imageCornerRoundness, buttonRadius],
  );
};

export const useImageCornerRoundness = () => {
  const { imageCornerRoundness } = useSiteConfigurations();

  useEffect(() => {
    if (!isEmpty(imageCornerRoundness)) {
      document.documentElement.style.setProperty('--image-corner-roundness', `${imageCornerRoundness}px`);
    }

    return () => {
      document.documentElement.style.removeProperty('--image-corner-roundness');
    };
  }, [imageCornerRoundness]);
};
